<template>
  <PageWrapper>
    <MediaMain
      :medium="media"
      :data-loaded="dataLoaded"
    />
    <MediaOtherArticles :media="otherMedia" />
  </PageWrapper>
  <BaseModal modal-id="modal-media-image">
    <ModalMediaImage />
  </BaseModal>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'

import RetailApiV2 from '@/api/retailApi/RetailApiV2'
import BaseModal from '@/components/general/BaseModal.vue'
import PageWrapper from '@/components/general/BasePageWrapper.vue'
import MediaMain from '@/components/media/MediaMain.vue'
import MediaOtherArticles from '@/components/media/MediaOtherArticles.vue'
import ModalMediaImage from '@/components/modals/ModalMediaImage.vue'
import useHead from '@/mixins/headManager'
import { useNavbarStore } from '@/stores/NavbarStore'

const { t } = useI18n()
const route = useRoute()
const baseUrl = import.meta.env.VITE_VUE_APP_ORIGINAL_URL
const url = (baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl) + route.path
const dataLoaded = ref(false)

useHead({
  title: t('media_about_us'),
  link: [
    {
      rel: 'canonical',
      href: url,
    },
  ],
})
const { params } = route
const permalink = ref()
const media = ref({})
const otherMedia = ref([])

const { setDefault } = useNavbarStore()

setDefault()

onBeforeRouteUpdate((to, from, next) => {
  permalink.value = to.params.permalink
  loadData()
  next()
})

const loadData = async () => {
  const {
    data: { medium },
  } = await RetailApiV2.get(`media/${permalink.value}`)
  media.value = medium

  const { data } = await RetailApiV2.get(`media?limit=4&year=${medium.year}`)
  otherMedia.value = data.media

  dataLoaded.value = true
}

onMounted(() => {
  permalink.value = params.permalink
  loadData()
})
</script>

<i18n>
  {
    "cs": {
    "media": "Média",
    "media_about_us": "Média o nás"
},
    "sk": {
    "media": "Médiá",
    "media_about_us": "Médiá o nás"
},
    "pl": {
    "media": "Media",
    "media_about_us": "Media o nas"
},
    "hu": {
    "media": "Megjelenéseink",
    "media_about_us": "Rólunk a médiában"
},
    "de": {
    "media": "Medien",
    "media_about_us": "Medien über uns"
},
    "at": {
    "media": "Medien",
    "media_about_us": "Medien über uns"
},
    "ro": {
    "media": "Media",
    "media_about_us": "Media despre noi"
},
    "fr": {
    "media": "Ce sont les médias",
    "media_about_us": "Médias à propos de nous"
},
    "it": {
    "media": "Media",
    "media_about_us": "Media su di noi"
}
  }
</i18n>
